import { h } from "snabbdom";
import { previewHost } from "../editor/preview";
import { PREVIEW_LINES } from "../preview-limits";
import type { VNode } from "snabbdom";
import type { CardSummary, Modal, Msg } from "../types";

export function viewModal(modal: Modal, dispatch: (msg: Msg) => void): VNode {
  return h(
    "div.modal-overlay",
    { on: { click: () => dispatch({ type: "CloseModal" }) } },
    [
      h(
        "div.modal",
        { on: { click: (e: Event) => e.stopPropagation() } },
        [
          h("div.modal__header", [
            h("h2.modal__title", "New card"),
            h(
              "button.modal__close",
              { on: { click: () => dispatch({ type: "CloseModal" }) } },
              "×"
            ),
          ]),
          h("input.modal__search", {
            attrs: { type: "text", placeholder: "Search templates…", value: modal.searchQuery },
            hook: { insert: (vn) => (vn.elm as HTMLInputElement).focus() },
            on: {
              input: (e: Event) =>
                dispatch({
                  type: "ModalSearch",
                  query: (e.target as HTMLInputElement).value,
                }),
            },
          }),
          h("div.modal__list", [
            // Always show "Blank card" tile first
            h(
              "div.modal__tile.modal__tile--blank",
              { on: { click: () => dispatch({ type: "CreateCard" }) } },
              [h("span.modal__tile-icon", "+"), h("span.modal__tile-label", "Blank card")]
            ),
            ...modal.results.map((card) => viewTemplateTile(card, dispatch)),
          ]),
          h("p.modal__hint", 'Only cards tagged "template" are shown here.'),
        ]
      ),
    ]
  );
}

function viewTemplateTile(
  card: CardSummary,
  dispatch: (msg: Msg) => void
): VNode {
  return h(
    "div.modal__tile.modal__tile--preview",
    { on: { click: () => dispatch({ type: "CreateCard", templateId: card.id }) } },
    [
      previewHost(card.content, 1, dispatch, PREVIEW_LINES.template),
    ]
  );
}
